var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKelaminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 3L14.2 8M19.2 3H15.2M19.2 3V7M11.2 16V22M8.19995 19H14.2M7.19995 11C7.19995 12.0609 7.62138 13.0783 8.37152 13.8284C9.12167 14.5786 10.1391 15 11.2 15C12.2608 15 13.2782 14.5786 14.0284 13.8284C14.7785 13.0783 15.2 12.0609 15.2 11C15.2 9.93913 14.7785 8.92172 14.0284 8.17157C13.2782 7.42143 12.2608 7 11.2 7C10.1391 7 9.12167 7.42143 8.37152 8.17157C7.62138 8.92172 7.19995 9.93913 7.19995 11Z",
    stroke: "#358888",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKelaminIcon);
export default __webpack_public_path__ + "static/media/kelamin_icon.4cee7b1d1af82cc9c54ef20b5d8ad868.svg";
export { ForwardRef as ReactComponent };